// extracted by mini-css-extract-plugin
module.exports = {"SubHeading":"SubHeading_SubHeading__1-cyN"};